import { ENDPOINTS, getFullUrl } from './apiConfig';

/**
 * Returns the full URL for the company logo given a company_id.
 * @param {string} companyId
 * @returns {string} Full URL to the company logo image
 */
export const getCompanyLogoUrl = (companyId) => {
  if (!companyId) return '';
  const endpoint = ENDPOINTS.GET_COMPANY_LOGO.replace(':company_id', companyId);
  return getFullUrl(endpoint);
};

/**
 * Registers a new company via the API.
 * @param {object} companyData - The company data object
 * @returns {Promise<object>} - A promise that resolves with the API response data.
 * @throws {Error} - Throws an error if the API call fails or returns a non-OK status.
 */
export const registerCompany = async (companyData) => {
  const url = getFullUrl(ENDPOINTS.COMPANY_REGISTRATION);
  
  console.log('Sending POST request to register company:', url);
  console.log('Payload:', JSON.stringify(companyData, null, 2));

  // Create FormData for file upload
  const formData = new FormData();
  formData.append('company_name', companyData.company_name);
  formData.append('company_type', companyData.company_type);
  formData.append('company_registration_number', companyData.company_registration_number);
  formData.append('company_address', companyData.company_address);
  
  // Append logo file if provided
  if (companyData.company_logo) {
    formData.append('company_logo', companyData.company_logo);
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      body: formData, // Don't set Content-Type header, let browser set it for FormData
    });

    if (!response.ok) {
      const errorDetails = await response.json().catch(() => ({})); 
      console.error('API Error Response (Register Company):', response.status, response.statusText, errorDetails);
      
      let errorMessage = `API Error: ${response.status} ${response.statusText}`;
      if (errorDetails.detail) {
        errorMessage += ` - ${errorDetails.detail}`;
      } else if (typeof errorDetails === 'object' && errorDetails !== null) {
        const errors = Object.entries(errorDetails)
          .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`)
          .join('; ');
        if (errors) errorMessage += ` - ${errors}`;
      }
      
      throw new Error(errorMessage);
    }

    const result = await response.json();
    console.log('API Success Response (Register Company):', result);
    return result;

  } catch (error) {
    console.error('Network or Fetch Error registering company:', error);
    // Re-throw API errors directly, wrap others
    if (error.message.startsWith('API Error:')) {
      throw error; 
    } else {
      throw new Error(`Network error: ${error.message}`);
    }
  }
};